export default __webpack_public_path__ + "static/media/down.7afbe8bc.svg";